/* eslint-disable @typescript-eslint/no-explicit-any */
import { FooterVariant } from 'types/global';

import ConnectFooter from 'components/ConnectFooter';

import { FooterLandingWithBuilder } from 'layout/Landing/footer/FooterLanding';
import { FooterWithBuilder } from 'layout/footer';

import type { FC } from 'react';

type FooterVariantProps = {
  variantFooter?: FooterVariant;
  preview?: boolean;
  landingContent?: any;
  globalContent?: any;
};

const FooterVariantWrapper: FC<FooterVariantProps> = ({
  variantFooter = 'default',
  preview,
  landingContent,
  globalContent,
}) => {
  if (variantFooter === 'hidden') {
    return null;
  }

  if (variantFooter === 'standardGlobal') {
    return <FooterWithBuilder content={globalContent} preview={preview} />;
  }

  if (variantFooter === 'connect') {
    return <ConnectFooter />;
  }

  return <FooterLandingWithBuilder content={landingContent} preview={preview} />;
};
export default FooterVariantWrapper;
